import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { AdapterDayjs } from 'EmbarkAdapterDayJS';
import { USER_LOCALE } from '../util/environment';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
const userLocaleSearchValue = USER_LOCALE.toLowerCase();
let booLocaleMatchFound = false;
// if we're using vite; else, if we're using webpack
if (import.meta.env) {
    /*
        Import all locale files
        https://vitejs.dev/guide/features.html#glob-import
    */
    const requireLocale = import.meta.glob('../../node_modules/dayjs/locale/*.js');
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const fileName in requireLocale) {
        if (fileName.includes(userLocaleSearchValue)) {
            booLocaleMatchFound = true;
        }
    }
}
else {
    /*
        Import all locale files
        https://webpack.js.org/guides/dependency-management/#requirecontext
    */
    const requireLocale = require.context('dayjs/locale', false, /.js$/);
    requireLocale.keys().forEach((fileName) => {
        requireLocale(fileName);
        if (fileName.includes(userLocaleSearchValue)) {
            booLocaleMatchFound = true;
        }
    });
}
// fallback to root locale if no match is found in dayjs/locale (en-US > en)
const userLocale = booLocaleMatchFound
    ? userLocaleSearchValue
    : userLocaleSearchValue.split('-')[0];
dayjs.locale(userLocale);
export const dateAdapterInstance = new AdapterDayjs({ locale: userLocale });
export const formatDate = (date, formatKey = 'keyboardDate') => dateAdapterInstance.format(dayjs(date), formatKey);
export const formatDateTime = (date, formatKey = 'L h:mm:ss A') => dateAdapterInstance.formatByString(dayjs(date), formatKey);
export const getTimezone = (date) => dayjs(date).format('z');
export const isValidDate = (date) => date.getFullYear() > 1;
export const dateToISOString = (date) => dayjs(date).toISOString();
export const dayJsFormatDate = (date, format) => dayjs(date).format(format);
export const calculateSeconds = (duration) => {
    if (duration === 0) {
        return '0s';
    }
    const timeComponents = [
        { value: Math.floor(duration / (24 * 3600)), label: 'd' },
        { value: Math.floor((duration % (24 * 3600)) / 3600), label: 'h' },
        { value: Math.floor((duration % 3600) / 60), label: 'm' },
        { value: Math.floor(duration % 60), label: 's' }
    ];
    const formattedTime = timeComponents
        .filter((component) => component.value > 0)
        .map((component) => `${component.value}${component.label}`)
        .join(' ');
    return formattedTime;
};
export default AdapterDayjs;
